import { DirectorStore } from "services/director/directorStore";
import { DirectorUpdateData } from "services/director/directorTypes";
import type { NameExtensionFormValues } from "services/questions/gb/identityConstants";
import type { SumsubApplicationStore } from "services/sumsub/sumsubApplicationStore";
import { FormValidationError } from "types/form";

export enum IdentityStepEntity {
  NameExtension = "NameExtension",
}

export class IdentityStepStore {
  constructor(
    private readonly _directorStore: DirectorStore,
    protected readonly _sumsubApplicationStore: SumsubApplicationStore,
  ) {}

  async updateEntity(data: NameExtensionFormValues, entity: IdentityStepEntity): Promise<void> {
    switch (entity) {
      case IdentityStepEntity.NameExtension:
        try {
          const director = this._directorStore.getMainDirector();
          await this._directorStore.updateDirector(
            director.id,
            new DirectorUpdateData({
              firstName: data.firstName?.trim(),
              middleNames: data.middleNames?.trim() || undefined,
              lastName: data.lastName?.trim(),
            }),
          );
          await this._sumsubApplicationStore.getSumsubApplication();
        } catch (e) {
          console.error("Failed to update director name extension", e);
          throw new FormValidationError("Failed to update name. Please try again.");
        }
    }
  }
}
